import { toastError } from 'admination-react'
import { ModalAction } from '../ModalAction'
import { useCoachingString } from '../useCoachingString'
import { useEffect, useRef, useState } from 'react'
import { useApp } from '@/core/state/appStore'

import { getAnwesenheitslistePath, confirmTeilnehmendenliste } from '../../../flows/anwesenheitsliste'
import { handleFailure } from '@/core/lib/toast'
import { ModalHeader } from '@/core/components/modal/ModalHeader'
import { PdfRegion } from '@/core/components/modal/PdfRegion'

export function AnwesenheitslisteDokument({ coachingId }: { coachingId: string | null }) {
  const { dispatch, reloadDashboard } = useApp()
  const [confirming, setConfirming] = useState(false)
  const alive = useRef(true)
  useEffect(() => {
    alive.current = true
    return () => {
      alive.current = false
    }
  }, [])

  const [path] = useCoachingString(coachingId, getAnwesenheitslistePath)

  function proceed() {
    if (!coachingId) return
    setConfirming(true)
    confirmTeilnehmendenliste(coachingId)
      .then((result) => {
        setConfirming(false)
        if ('ok' in result) {
          handleFailure(result)
          return
        }
        reloadDashboard()
        if (alive.current) dispatch({ type: "CHANGE_TAB", tab: 'zertifikat' })
      })
      .catch((e) => {
        setConfirming(false)
        console.error('Teilnehmendenliste bestätigen fehlgeschlagen:', e)
        toastError('Teilnehmendenliste bestätigen fehlgeschlagen.')
      })
  }

  return (
    <>
      <ModalHeader size="document">
        <div className="pill-cluster">
          <ModalAction
            icon="i-check"
            primaryAction
            title="Bestätigen"
            loading={confirming}
            disabled={confirming}
            onClick={proceed}
          />
        </div>
      </ModalHeader>
      <PdfRegion
        path={path ?? null}
        waiting={path === undefined}
        loadingLabel="Teilnehmendenliste wird geladen …"
        placeholder="Noch keine Teilnehmendenliste vorhanden."
      />
    </>
  )
}
